var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInteractiveImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    fill: "white",
    stroke: "#FFBE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1913 19.4743C18.6588 17.4565 20 14.9231 20 12.5C20 9.73858 17.7614 7.5 15 7.5C12.2386 7.5 10 9.73858 10 12.5C10 14.9231 11.3412 17.4565 12.8087 19.4743C13.5288 20.4645 14.2508 21.292 14.7929 21.8717C14.8654 21.9492 14.9346 22.0222 15 22.0905C15.0654 22.0222 15.1346 21.9492 15.2071 21.8717C15.7492 21.292 16.4712 20.4645 17.1913 19.4743ZM15 23.5C15 23.5 21 18 21 12.5C21 9.18629 18.3137 6.5 15 6.5C11.6863 6.5 9 9.18629 9 12.5C9 18 15 23.5 15 23.5Z",
    fill: "#FFBE5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.5C16.1046 14.5 17 13.6046 17 12.5C17 11.3954 16.1046 10.5 15 10.5C13.8954 10.5 13 11.3954 13 12.5C13 13.6046 13.8954 14.5 15 14.5ZM15 15.5C16.6569 15.5 18 14.1569 18 12.5C18 10.8431 16.6569 9.5 15 9.5C13.3431 9.5 12 10.8431 12 12.5C12 14.1569 13.3431 15.5 15 15.5Z",
    fill: "#FFBE5C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveImageIcon);
export default __webpack_public_path__ + "static/media/interactiveImage_icon.bd1054b0a728e103f836cf74fb933e21.svg";
export { ForwardRef as ReactComponent };